namespace GeniuzPOS.ReportMasterData {
    export interface Report_1602Row {
        Id?: string;
        PluCode?: string;
        PluFullName?: string;
        PluShortDesc?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SupplId?: string;
        SupplName?: string;
        SupplFullName?: string;
        GpPc?: number;
        Qty?: number;
        UnitPrice?: number;
        GrossSales?: number;
        NetsalesafterGp?: number;
        Gpamt?: number;
        ItemPromoId?: string;
    }

    export namespace Report_1602Row {
        export const idProperty = 'Id';
        export const nameProperty = 'PluCode';
        export const localTextPrefix = 'ReportMasterData.Report_1602';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:สินค้าฝากขาย:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:สินค้าฝากขาย:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:สินค้าฝากขาย:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:สินค้าฝากขาย:View';

        export declare const enum Fields {
            Id = "Id",
            PluCode = "PluCode",
            PluFullName = "PluFullName",
            PluShortDesc = "PluShortDesc",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SupplId = "SupplId",
            SupplName = "SupplName",
            SupplFullName = "SupplFullName",
            GpPc = "GpPc",
            Qty = "Qty",
            UnitPrice = "UnitPrice",
            GrossSales = "GrossSales",
            NetsalesafterGp = "NetsalesafterGp",
            Gpamt = "Gpamt",
            ItemPromoId = "ItemPromoId"
        }
    }
}
